import mock from '../mock'

const autoComplete = [
  {
    title: 'The Shawshank Redemption',
    rank: '1',
    id: 'tt0111161'
  }
]

mock.onGet('/api/autocomplete/data').reply(200, {
  autoComplete
})
